import React from "react";
import Lottie from "react-lottie";
import animationData from "./29142-error-404.json";
import LandingData from "./Landing.json";
import JoinNow from "./GetInTouch.json";

export const Error404 = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return <Lottie height={400} width={400} options={defaultOptions} />;
};

export const Landing = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LandingData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return <Lottie height={300} width={760} options={defaultOptions} />;
};

export const Join = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: JoinNow,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return <Lottie options={defaultOptions} height={380} width={700} />;
};
